export default __webpack_public_path__ + "9aee34ab72de535231b33739c07e9f81.PNG";